import React, { useState } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import Iconify from 'src/components/Iconify';
import ArquivoCard from './ArquivoCard';
import { CHATS_ARQUIVADAS_DESIGN as D, getCorDivisao } from './ChatsArquivadas.design';

export default function ArquivoColumn({
    divisao,
    chats,
    podeGerenciar,
    onAbrirChat,
    onDesarquivar,
    onEditarDivisao,
    onExcluirDivisao
}) {
    const [menuAberto, setMenuAberto] = useState(false);
    const cor = getCorDivisao(divisao.cor_hex);
    const divisaoId = `${divisao._id}`;

    return (
        <div className={D.board.column}>
            <div className={D.board.columnHeader}>
                <div className={`w-6 h-6 rounded-lg flex items-center justify-center ${cor.bg}`}>
                    <Iconify icon={divisao.icone || 'eva:folder-outline'} width={14} className={cor.text} />
                </div>
                <p className={D.board.columnTitle}>{divisao.nome}</p>
                <span className={D.board.columnCount}>{chats.length}</span>

                {podeGerenciar && (
                    <div className="relative">
                        <button
                            type="button"
                            className={D.board.columnMenu}
                            onClick={() => setMenuAberto((atual) => !atual)}
                        >
                            <Iconify icon="eva:more-vertical-fill" width={14} />
                        </button>

                        {menuAberto && (
                            <>
                                <div className="fixed inset-0 z-10" onClick={() => setMenuAberto(false)} />
                                <div className="absolute right-0 top-7 z-20 w-40 bg-white rounded-xl border border-gray-100 shadow-lg py-1">
                                    <button
                                        type="button"
                                        className="w-full flex items-center gap-2 px-3 py-2 text-xs text-gray-600 hover:bg-gray-50 transition-colors"
                                        onClick={() => {
                                            setMenuAberto(false);
                                            onEditarDivisao(divisao);
                                        }}
                                    >
                                        <Iconify icon="eva:edit-2-outline" width={14} />
                                        Editar divisão
                                    </button>
                                    <button
                                        type="button"
                                        className="w-full flex items-center gap-2 px-3 py-2 text-xs text-red-600 hover:bg-red-50 transition-colors"
                                        onClick={() => {
                                            setMenuAberto(false);
                                            onExcluirDivisao(divisao);
                                        }}
                                    >
                                        <Iconify icon="eva:trash-2-outline" width={14} />
                                        Excluir
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                )}
            </div>

            <Droppable droppableId={divisaoId} type="card">
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className={`${D.board.columnBody} ${snapshot.isDraggingOver ? D.board.columnBodyDragging : ''}`}
                    >
                        {chats.map((chat, index) => (
                            <ArquivoCard
                                key={`${chat._id}`}
                                chat={chat}
                                index={index}
                                onAbrir={onAbrirChat}
                                onDesarquivar={onDesarquivar}
                            />
                        ))}
                        {provided.placeholder}

                        {!chats.length && !snapshot.isDraggingOver && (
                            <div className="flex flex-col items-center justify-center py-8 text-center">
                                <Iconify icon="eva:inbox-outline" width={24} className="text-gray-300 mb-1.5" />
                                <p className="text-[11px] text-gray-400">Nenhuma conversa aqui</p>
                            </div>
                        )}
                    </div>
                )}
            </Droppable>
        </div>
    );
}
